import Header from "~/components/header"
import Typography from "~/components/typography"
import { MetaFunction } from "@remix-run/node"

export const meta: MetaFunction = () => {
  return [
    { title: "Talk to us" },
    { property: "og:title", content: "Talk to us" },
    { name: "description", content: "Questions? Feedback? Troubles? Contact us!" },
  ]
}

export default function VideoSubmissionAgreement() {
  return (
    <div className="max-w-5xl m-auto mt-16 mt-16">
      <Header title="Talk to us" />
      <Typography className="mx-4 md:mx-16">
        <h3>Questions about curation, profiles, etc?</h3>
        <p>
          Email <a href="mailto:curators@makelovenotporn.tv">curators@makelovenotporn.tv</a>
        </p>
        <h3>Tech or billing troubles? General site stuff?</h3>
        <p>
          Email <a href="mailto:support@makelovenotporn.tv">support@makelovenotporn.tv</a>
        </p>
        <h3>Feedback, comments, suggestions?</h3>
        <p>
          Email <a href="mailto:feedback@makelovenotporn.tv">feedback@makelovenotporn.tv</a>
        </p>
        <h3>If you’re a brand/business interested in working with MLNP.tv:</h3>
        <p>
          Email <a href="mailto:cindy@makelovenotporn.tv">cindy@makelovenotporn.tv</a>
        </p>
      </Typography>
    </div>
  )
}
